module.exports = __webpack_public_path__ + "static/media/0018.eeb99bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/RAL/0018.png
// module id = 528
// module chunks = 0